import { render, staticRenderFns } from "./omt-buttons-bar.vue?vue&type=template&id=6a8a07e6&scoped=true&"
var script = {}
import style0 from "./omt-buttons-bar.vue?vue&type=style&index=0&id=6a8a07e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a07e6",
  null
  
)

export default component.exports